import Anomalies from './Anomalies';

export default Anomalies;
